<template>
<div class="">
  <div class="topjob">
        <div class="nametitle">我的协作空间</div>
        <div class="create" @click="createSpace">+ 新建空间</div>
      </div>
      <div class="projectList custom-scrollbar">
        <div v-if="projectList.length !== 0">
          <div class="item" v-for="(item, index) in projectList" :key="index">
            <div class="itemtop" @click="toSpace(item.id)">
              <div class="l">{{ item.name }}</div>
              <div class="r">
                <div class="ri1">
                  <img src="@/assets/images/r1.png" alt="">
                  发布公开
                </div>
                <div class="ri1">
                  <img src="@/assets/images/r2.png" alt="">
                  分享协作
                </div>
                <div class="ri1">
                  <img src="@/assets/images/r3.png" alt="">
                  克隆
                </div>
                <div class="ri1">
                  <img src="@/assets/images/r4.png" alt="">
                  删除
                </div>
                <div class="ri1">
                  <img src="@/assets/images/r5.png" alt="">
                  编辑
                </div>
                <div class="ri2">
                  <img v-for="(item2, index2) in item.team" :src="item2.avatar" :key="index2" alt="">
                </div>
                <div class="ri3">
                  {{ item.team.length }}人协作
                </div>
              </div>
            </div>
            <div class="itembody custom-scrollbar">
              <div class="type" v-for="(item2, index2) in item.type" :key="index2">
                <div class="tl">
                  <div class="tl1">{{ item2.name }}</div>
                  <div class="tl2">{{ item2.des }}</div>
                </div>
                <div class="tr"><img :src="item2.img" alt=""></div>
              </div>
            </div>
            <div class="itembot">
              <div class="ib1">
                <img src="@/assets/images/people.png" alt="">{{ item.createName }}
              </div>
              <div class="ib1">
                <img src="@/assets/images/date.png" alt="">{{ item.time }}更新
              </div>
              <div class="ib2" v-if="item.status == 0"><img src="@/assets/images/time.png" alt=""><span>进行中</span>
                <div class="length">
                  <div class="step" :style="`width: ${item.step}`"></div>
                </div>完成进度{{ item.step }}
              </div>
              <div class="ib2" v-else><img src="@/assets/images/sc.png" alt=""><span>审查阶段</span></div>
            </div>
          </div>
        </div>
        <el-empty v-else description="暂无项目"></el-empty>
      </div>
</div>
</template>

<script>
export default {
  name: '',
  data () {
    return {
      projectList: [
        {
          team: [
            {
              name: 'yyy',
              avatar: require('@/assets/images/test.png')
            },
            {
              name: 'yyy',
              avatar: require('@/assets/images/test.png')
            },
            {
              name: 'yyy',
              avatar: require('@/assets/images/test.png')
            },
            {
              name: 'yyy',
              avatar: require('@/assets/images/test.png')
            },
            {
              name: 'yyy',
              avatar: require('@/assets/images/test.png')
            }
          ],
          type: [
            {
              name: '故事梗概',
              des: '简要概述',
              img: require('@/assets/images/type1.png')
            },
            {
              name: '故事梗概',
              des: '简要概述',
              img: require('@/assets/images/type1.png')
            },
            {
              name: '故事梗概',
              des: '简要概述',
              img: require('@/assets/images/type1.png')
            },
            {
              name: '故事梗概',
              des: '简要概述',
              img: require('@/assets/images/type1.png')
            },
            {
              name: '故事梗概',
              des: '简要概述',
              img: require('@/assets/images/type1.png')
            },
            {
              name: '故事梗概',
              des: '简要概述',
              img: require('@/assets/images/type1.png')
            },
            {
              name: '故事梗概',
              des: '简要概述',
              img: require('@/assets/images/type1.png')
            },
            {
              name: '故事梗概',
              des: '简要概述',
              img: require('@/assets/images/type1.png')
            },
            {
              name: '故事梗概',
              des: '简要概述',
              img: require('@/assets/images/type1.png')
            }
          ],
          projectname: '测试名1',
          step: '60%',
          time: '2025-08-23',
          createName: '杨杨杨',
          status: 0
        }
      ]
    }
  },
  async created () {
    const res = await this.$http('api.getProjects', {
      page: 1,
      limit: 100,
      status: 1
    })

    const list = res.data.list
    console.log(list, 'ress')
    const arr = []
    list.forEach(item => {
      arr.push({
        team: [
          {
            name: 'yyy',
            avatar: require('@/assets/images/test.png')
          },
          {
            name: 'yyy',
            avatar: require('@/assets/images/test.png')
          },
          {
            name: 'yyy',
            avatar: require('@/assets/images/test.png')
          },
          {
            name: 'yyy',
            avatar: require('@/assets/images/test.png')
          },
          {
            name: 'yyy',
            avatar: require('@/assets/images/test.png')
          }
        ],
        type: [
          {
            name: '故事梗概',
            des: '简要概述',
            img: require('@/assets/images/type1.png')
          },
          {
            name: '分镜脚本',
            des: '简要概述',
            img: require('@/assets/images/type2.png')
          },
          {
            name: '画面精修',
            des: '简要概述',
            img: require('@/assets/images/type3.png')
          },
          {
            name: '视频导出',
            des: '简要概述',
            img: require('@/assets/images/type4.png')
          },
          {
            name: '团队对话',
            des: '简要概述',
            img: require('@/assets/images/type5.png')
          },
          {
            name: '素材库',
            des: '简要概述',
            img: require('@/assets/images/type6.png')
          },
          {
            name: '时间线',
            des: '简要概述',
            img: require('@/assets/images/type7.png')
          },
          {
            name: '提案PPT',
            des: '简要概述',
            img: require('@/assets/images/type8.png')
          }
        ],
        name: item.name,
        id: item.id,
        step: '0%',
        time: '2025-08-23',
        createName: '暂无',
        status: 0
      })
    }

    )

    this.projectList = arr
  },
  mounted () {

  },
  methods:{
    toSpace(id){
      // this.$router.push(`/main/project/index?id=${item.id}`)
      location.href=`/#/project1?id=${id}`
    },
    createSpace(){
      // this.$router.push(`pc/#/creatspace`)
      location.href=`/#/creatspace`
    }
  }
}
</script>
<style lang="scss" scoped>
.projectList {
    height: 100%;
    padding: 20px;
    width: 100%;
    overflow-y: auto;

    .item {
      margin-bottom: 20px;
      width: 100%;
      height: 342px;
      background: #FFFFFF;
      box-shadow: 2px 4px 12px 0px rgba(59, 59, 59, 0.2);
      border-radius: 8px 8px 8px 8px;

      .itemtop {
        height: 56px;
        line-height: 56px;
        border-bottom: 1px solid #e7e7e7;
        padding: 0 20px;
        display: flex;
        justify-content: space-between;

        .l {
          font-size: 20px;
          color: #262626;
          font-weight: 600;
        }

        .r {
          display: flex;

          .ri1 {
            cursor: pointer;
            margin-left: 20px;
            font-size: 16px;
            color: #595959;

            img {
              width: 24px;
              margin-right: 2px;
              transform: translateY(-2px);
            }
          }

          .ri2 {
            width: 70px;
            overflow: hidden;
            margin-left: 20px;

            img {
              width: 28px;
              margin-right: -13px;
            }
          }

          .ri3 {
            margin-left: 20px;
          }
        }
      }

      .itembody {
        height: 240px;
        overflow-y: auto;
        padding: 20px;
        padding-bottom: 0;
        display: flex;
        flex-wrap: wrap;

        .type {
          margin-right: 16px;
          margin-bottom: 18px;
          width: 284px;
          height: 92px;
          background: #F8F8F8;
          border-radius: 2px 2px 2px 2px;
          padding: 16px;
          display: flex;
          cursor: pointer;

          .tl {
            width: 200px;

            .tl1 {
              font-size: 18px;
              color: #C77947;
            }

            .tl2 {
              font-size: 14px;
              color: #595959;
              margin-top: 10px;
            }
          }
          

          .tr {
            width: 48px;
            margin-left: 8px;

            img {
              width: 100%;
            }
          }
        }
        .type:nth-child(2) .tl .tl1{
            color: #1d1c1c;
          }
        // .type:nth-child(2) .tl .tl1 {
        //       color: #1ca010;
        //     }
        .tl:nth-child(2) .tl1{
            color: #046DFA;
          }
          .tl:nth-child(3) .tl1{
            color: #30DFA9;
          }
          .tl:nth-child(4) .tl1{
            color: #8C3AED;
          }
          .tl:nth-child(5) .tl1{
            color: #30DFA9;
          }
          .tl:nth-child(6) .tl1{
            color: #8C3AED;
          }
          .tl:nth-child(7) .tl1{
            color: #C77947;
          }
          .tl:nth-child(8) .tl1{
            color: #046DFA;
          }
        // .type:nth-child(4n) {
        //   margin-right: 0;
        // }
      }

      .itembot {
        height: 30px;
        line-height: 30px;
        padding: 0 20px;
        // display: flex;
        width: 100%;

        .ib1 {
          margin-right: 40px;
          float: left;

          img {
            width: 20px;
            margin-right: 6px;
            transform: translateY(-2px);
          }
        }

        .ib2 {

          float: right;
          display: flex;

          img {
            width: 20px;
            height: 20px;
            transform: translateY(6px);
          }

          span {
            margin: 0 6px;
            font-size: 16px;
            color: #046DFA;
          }

          .length {
            margin-top: 12px;
            width: 350px;
            height: 6px;
            background: #E6E6E6;
            border-radius: 12px 12px 12px 12px;
            margin-right: 6px;

            .step {
              height: 100%;
              border-radius: 12px 12px 12px 12px;
              background: #046DFA;
              width: 0%;
              transition: all .5s linear;
            }
          }
        }
      }
    }
  }
</style>
